import Algolia from 'algoliasearch'

export const defaultAlgoliaOptions = {
    page: 0,
    hitsPerPage: 30,
    typoTolerance: true,
    attributesToRetrieve: [
        'id',
        'name',
        'details',
        'grid_picture_url',
        'sku',
        'brand_name',
        // 'product_category',
        'release_date',
        'retail_price_cents_usd',
    ],
    distinct: true,
}

const client = Algolia('2FWOTDVM2O', '838ecd564b6aedc176ff73b67087ff43')

export const algolia = client.initIndex('product_variants_v2')
